module.exports = __webpack_public_path__ + "img/pyq.7b9b120c.png";